var History = require('backbone-torso/modules/history');
var sessionStorageService = require('./../../../storage/sessionStorageService');
var EregAuthErrorView = require('./EregAuthErrorView');

var SERIAL_NUMBER_PROPERTY_NAME = sessionStorageService.SESSION_STORAGE_KEYS.serialNumber;

/**
 * Error View when no Barcode Data was obtained
 *
 * @class NoBarcodeDataErrorView
 * @constructor
 */
module.exports = EregAuthErrorView.extend({
  errorMessageKey: 'eregAuth.error.NoBarcodeData.message.final',
  buttonOneMessageKey: 'eregAuth.error.button.ok',
  buttonTwoMessageKey: undefined,
  buttonTwoNavFunction: undefined,

  /**
   * @method initialize
   * @override
   * @param options {Object} configuration for this view
   *   @param options.tryAgain {Boolean} Flag to know if this view should show it's Try Again button or not
   */
  initialize: function(options) {
    var tryAgain = (options && options.tryAgain) || false;

    // For this Error there exists a state which you can try again from, requiring two buttons and nav functions
    if (tryAgain) {
      this.errorMessageKey = 'eregAuth.error.NoBarcodeData.message.retry';
      this.buttonOneMessageKey = 'eregAuth.error.button.tryAgain';
      this.buttonOneNavFunction = this.retryBarcode;
      this.buttonTwoMessageKey = 'eregAuth.error.button.cancel';
      this.buttonTwoNavFunction = function() {
        History.navigate('tablet/serialNumber/' + sessionStorageService.getItem(SERIAL_NUMBER_PROPERTY_NAME), {trigger: true});
      };
    }

    this.listenTo(this.viewState, 'change:canTryAgain', this.render);
  },

  /**
   * Triggers a retryBarcode event for the parent view to listen to
   * and disposes itself
   */
  retryBarcode: function() {
    this.trigger('retryBarcode');
  }
});
